// Previously received money, entered in the software for the first time at check-in.
export function readPriorCheckInAdvance(data={},recordedAdvance=0,tariff=Infinity) {
 const raw=Number(data.priorAdvanceAmount || 0);
 if(!Number.isFinite(raw)||raw<0)throw new Error('Advance amount valid aur 0 se kam nahi hona chahiye.');
 const amount=Math.round(raw*100)/100;
 if(amount>Number(tariff))throw new Error('Pehle received advance room tariff se zyada nahi hona chahiye.');
 if(amount>0&&Number(recordedAdvance)>0)throw new Error('Is booking ka advance already recorded hai. Use dobara Advance field mein na bharein.');
 const paymentMode=data.priorAdvanceMode || 'Cash';
 const transactionReference=paymentMode==='UPI'?String(data.priorAdvanceReference || '').trim():'';
 if(amount>0&&!['Cash','UPI'].includes(paymentMode))throw new Error('Advance payment mode Cash ya Online / UPI select karein.');
 if(amount>0&&paymentMode==='UPI'&&transactionReference.length<4)throw new Error('Pehle received advance ka Transaction Reference bharein (minimum 4 characters).');
 return {amount,paymentMode,transactionReference};
}
export function priorAdvancePayment(advance,recordedAt) {
 return advance.amount>0?{type:'payment',title:'Previously Received Advance',amount:advance.amount,quantity:1,rate:advance.amount,
 paymentMode:advance.paymentMode,transactionReference:advance.transactionReference,source:'check_in_prior_advance',
 addedAt:recordedAt,note:'Received before arrival; first recorded in software at check-in'}:null;
}
